// Banner.js
import React, { useEffect, useRef } from "react";
import './Intro.css';

const features = [
    {
        img: "iPhone-13.png",
        title: "Browse Unlimited Profiles",
        desc: "Explore a vast selection of verified profiles tailored to your preferences. Filter your search and discover potential matches effortlessly.",
    },
    {
        img: "iPhone-14.png",
        title: "View & Start Chat",
        desc: "Check detailed profiles and start a conversation with just a tap. Connect through chat, voice, or video calls securely.",
    },
    {
        img: "iPhone-15.png",
        title: "Compatibility Check",
        desc: "Get a smart compatibility score based on shared interests and values. Understand how well you match before taking the next step.",
    }
];

const Intro = () => {
    return (
        <div className="feature-grid">
            {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                    <img src={process.env.PUBLIC_URL + "/images/" + feature.img} alt={feature.title} className="feature-img" />
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-desc">{feature.desc}</p>
                </div>
            ))}
        </div>
    );
};

export default Intro;
